import { ABORT_ERROR } from '../util/abortControl';
import { makeError } from '../util/exception';

export type AbortableSleep = (durationMs: number, signal: AbortSignal) => Promise<void>;

export function abortableSleep(durationMs: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal.aborted) {
      reject(signal.reason ?? new Error('Sleep aborted with signal'));
      return;
    }
    let timeoutId: any = undefined;
    const listener = () => {
      clearTimeout(timeoutId);
      reject(makeError('Aborted', ABORT_ERROR, {
        cause: signal.reason,
      }));
    };
    signal.addEventListener('abort', listener);

    timeoutId = setTimeout(() => {
      signal.removeEventListener('abort', listener);
      resolve();
    }, durationMs);
  });
}
